import React, { useState, useEffect, useRef } from 'react'
import { Container, Button, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { XLg } from "react-bootstrap-icons";
import Form from "react-bootstrap/Form";
import "./styles.scss";

const CompanySelectionFilterBox = (props) => {
    const [selectedStatuses, setSelectedStatuses] = useState(props.status || []);             // selected status
    const [selectedAll, setSelectedAll] = useState(props.allStateSelected || false);          // all option selected flag
    const filterBoxRef = useRef(null);                                                        // useRef hook
    const available_statuses = ['Active', 'InActive'];                                        // dropdown statuses


    // Function to update selected statuses
    const handleStatusChange = (status) => {
        setSelectedStatuses((prevSelectedStatuses) => {
            if (prevSelectedStatuses.includes(status)) {
                return prevSelectedStatuses.filter((statusId) => statusId !== status);
            } else {
                return [...prevSelectedStatuses, status];
            }
        });
        setSelectedAll(false);
    };

    // Function to handle "All Statuses" checkbox
    const handleAllStatusesChange = (isChecked) => {
        if (isChecked) {
            setSelectedAll(true);
        } else {
            setSelectedAll(false);
        }
        setSelectedStatuses([]);
    };

    // useEffect
    useEffect(() => {
        const handleClickOutside = (event) => {
            const filterButton = document.getElementById('filterblock');
            const filterButtonActive = document.querySelector('.filter-black-active');

            const isFilterClick = filterButton?.contains(event.target) ||
                                filterButtonActive?.contains(event.target);

            if (isFilterClick) {
                return;
            }

            // If click is outside filter box and not on filter button, close the box
            if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
                props.setShowFilterBox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {available_statuses && <div className="filter-box filter-box-xxsm" ref={filterBoxRef}>
                <Container>
                    <Col className="d-flex justify-content-between d-md-none align-items-center px-8 flex-grow-0">
                        <h2>Filters</h2>
                        <XLg size={16} onClick={() => props.setShowFilterBox(false)} />
                    </Col>



                    <Row className="mb-3 mobile-filter-row">
                        <Col className="filter-column">

                            <h3 className="mb-3">Status</h3>
                            <div>
                                <div className="filter-options">
                                    <>
                                        {available_statuses && available_statuses.length > 0 && <Form.Check
                                            className="mb-2"
                                            type="checkbox"
                                            id={`status-all`}
                                            label="All"
                                            checked={selectedAll}
                                            onChange={(e) => handleAllStatusesChange(e.target.checked)}
                                        />}
                                        {available_statuses && available_statuses.length > 0 &&
                                            available_statuses.map((statusItem) => {
                                                return (
                                                    <Form.Check
                                                        className="mb-2"
                                                        key={statusItem}
                                                        type="checkbox"
                                                        id={`status-${statusItem}`}
                                                        label={statusItem}
                                                        checked={selectedStatuses.includes(statusItem.toLowerCase())}
                                                        onChange={() => handleStatusChange(statusItem.toLowerCase())}
                                                    />
                                                );
                                            })
                                        }
                                    </>
                                </div>
                            </div>

                        </Col>
                    </Row>

                    <Row className="actions-row">
                        <Col className="d-flex">

                            {(selectedStatuses.length > 0 || selectedAll)
                                ? <Button
                                    className="btn btn-lg mx-3 btn-border-light"
                                    variant="light"
                                    onClick={() => {
                                        props.setFilterFlag(false);
                                        setSelectedAll(false);
                                        setSelectedStatuses([]);
                                        props.setStatus([]);
                                        props.setAllStateSelected(false);
                                    }}
                                >
                                    Clear
                                </Button> :
                                <Button
                                    className="btn btn-lg mx-3"
                                    variant="light"
                                    disabled
                                >
                                    Clear
                                </Button>
                            }
                            {selectedStatuses.length > 0 || selectedAll ? (
                                <Button
                                    className="btn btn-lg"
                                    variant="primary"
                                    onClick={() => {
                                        props.setStatus(selectedStatuses);
                                        props.setShowFilterBox(false);
                                        props.setFilterFlag(selectedStatuses.length > 0 || selectedAll);
                                        props.setAllStateSelected(selectedAll);
                                    }}
                                >
                                    Apply
                                </Button>
                            ) : (

                                <Button
                                    className="btn btn-lg"
                                    variant="light"
                                    disabled
                                >
                                    Apply
                                </Button>
                            )
                            }
                        </Col>
                    </Row>
                </Container>
            </div>}
        </>
    )
}

export default CompanySelectionFilterBox